/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AvailableFiltersResponseAvailableFiltersInner } from './AvailableFiltersResponseAvailableFiltersInner';
import {
    AvailableFiltersResponseAvailableFiltersInnerFromJSON,
    AvailableFiltersResponseAvailableFiltersInnerFromJSONTyped,
    AvailableFiltersResponseAvailableFiltersInnerToJSON,
} from './AvailableFiltersResponseAvailableFiltersInner';

/**
 * 
 * @export
 * @interface AvailableFiltersResponse
 */
export interface AvailableFiltersResponse {
    /**
     * 
     * @type {Array<AvailableFiltersResponseAvailableFiltersInner>}
     * @memberof AvailableFiltersResponse
     */
    availableFilters: Array<AvailableFiltersResponseAvailableFiltersInner>;
}

/**
 * Check if a given object implements the AvailableFiltersResponse interface.
 */
export function instanceOfAvailableFiltersResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "availableFilters" in value;

    return isInstance;
}

export function AvailableFiltersResponseFromJSON(json: any): AvailableFiltersResponse {
    return AvailableFiltersResponseFromJSONTyped(json, false);
}

export function AvailableFiltersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailableFiltersResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'availableFilters': ((json['available_filters'] as Array<any>).map(AvailableFiltersResponseAvailableFiltersInnerFromJSON)),
    };
}

export function AvailableFiltersResponseToJSON(value?: AvailableFiltersResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'available_filters': ((value.availableFilters as Array<any>).map(AvailableFiltersResponseAvailableFiltersInnerToJSON)),
    };
}

